"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JourneyNodeDirectionEnum = void 0;
var JourneyNodeDirectionEnum;
(function (JourneyNodeDirectionEnum) {
    JourneyNodeDirectionEnum["Input"] = "input-only";
    JourneyNodeDirectionEnum["Output"] = "output-only";
    JourneyNodeDirectionEnum["InputOutput"] = "input-output";
})(JourneyNodeDirectionEnum = exports.JourneyNodeDirectionEnum || (exports.JourneyNodeDirectionEnum = {}));
